<template>
  <div class="page with-navbar">
    <div class="container" style="position: relative;">
      <!-- 切换全国和本地 -->
      <div class="filter-bar gradient-bg">
        <div class="filter-bar-wrapper">
          <div><img src="~@static/funding_jolin/home/icon-location.png" class="pin-icon"></div>
          <div class="select-btn active">
            <div class="text" @click="handleClickItem">{{filterParam.city}}</div>
            <img src="~@static/funding_jolin/home/icon-arrow-white.png" class="icon" v-if="filterParam.city=='全国'"
              @click="handleClickItem">
            <img src="~@static/fundingnew/calendar/icon-del.png" class="icon" v-else @click="reset">
          </div>
        </div>
      </div>
      <div class='calendar_title'>
        <div class='icon' @click='lastMonth'>
          <img src="~@static/fundingnew/calendar/icon-prev.png" />
        </div>
        <div>{{month}}</div>
        <div class='icon' @click='nextMonth'>
          <img src="~@static/fundingnew/calendar/icon-next.png" />
        </div>
      </div>

      <!-- 日历主体 -->
      <div class="calendar">
        <div class="header">
          <div v-for="(item,index) in date" :key="index" :class="{weekMark: (index == todayIndex) && isTodayWeek}">
            {{item}}
            <div></div>
          </div>
        </div>

        <div class="date-box">
          <div v-for="(item,index) in dateArr" :key="index">
            <div
              :class="[{'nowDay':isToday == item.isToday},{'hasActivities':item.hasActivities},{'selectedDay':item.isToday == selectedDay}]">
              <div class='date-head' @click='showFunding' :data-year='year' :data-month='month'
                :data-datenum='item.dateNum' :data-date='item.isToday' :data-hasactivities='item.hasActivities'>
                <div>{{item.dateNum}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="funding-container">
        <div class="project-list-container gradient-bg" v-if="fundingData.length > 0">
          <div class="date">{{selectedDate}}</div>
          <p class="slogen" v-if="selectedDate == '12.31'">即刻点击参与百城跨年，和绝对伏特加一起<br />COME OUT AND PLAY 告别2020！</p>
          <div class="project-list clearfix">
            <project-item v-for="item of fundingData" :key="item.id" :projectData="item" :hasTags="true" :hasDesc="true"
              :hasProcess="true" :hasLink="true" :hasTheme="true" :isAnnouncement="false" :isWeekly="false"
              :isCalendar="true"></project-item>
          </div>
        </div>
      </div>
    </div>
    <rebuild-nav-bar></rebuild-nav-bar>
    <fill-modal :isShow.sync="isShowProvince" @confirm="bindProvinceConfirm" :maskClick="true">
      <div class="profile-datepicker">
        <div class="modal-title">请选择你所在的省份</div>
        <div class="datepicker-wrap">
          <van-picker :item-height="pickerItemHeight" :columns="columns" columns-num="2" visible-item-count="3"
            @change="handleCityChange" />
        </div>
      </div>
    </fill-modal>
  </div>
</template>

<script>
import provinces from '@javascripts/cities.js'
import RebuildNavBar from '@components/RebuildNavBar'
import ProjectItem from '../components/ProjectItem'
import FillModal from '../components/FillModal'

export default {
  name: '',
  components: {
    RebuildNavBar,
    ProjectItem,
    FillModal,
  },
  data() {
    return {
      hostUrl: this.$apiConfig.host,
      domainUrl: this.$apiConfig.domain,
      year: 0,
      month: 0,
      date: ['一', '二', '三', '四', '五', '六', '日'],
      dateArr: [],
      isToday: 0,
      isTodayWeek: false,
      todayIndex: 0,
      fundingData: [],
      allFundingData: [],
      filterParam: {
        city: '全国',
        date: '',
      },
      isShowProvince: false,
      selectedDay: '',
      // 城市
      columns: [],
      selectProvince: ['河北省', '石家庄市'],
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },
  computed: {
    pickerItemHeight() {
      return (56 / (375 * 2)) * 100 + 'vw'
    },
  },
  mounted() {
    this.initProvince()
    let now = new Date()
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let day = now.getDate()
    this.dateInit()
    this.year = year
    this.month = month
    this.day = day
    this.isToday = '' + year + (month < 10 ? '0' + month : month) + (now.getDate() < 10 ? '0' + now.getDate() : now.getDate())
    this.getActivities(year, month)
  },
  methods: {
    initProvince: function () {
      let mapData = []
      provinces.citiesData.provinces.forEach(item => {
        let obj = {
          text: item.provinceName,
          children: item.citys.map(item2 => {
            return {
              text: item2.citysName,
            }
          }),
        }
        mapData.push(obj)
      })
      this.columns = mapData
    },
    dateInit: function (setYear, setMonth) {
      //全部时间的月份都是按0~11基准，显示月份才+1
      let dateArr = [] //需要遍历的日历数组数据
      let arrLen = 0 //dateArr的数组长度
      let now = setYear ? new Date(setYear, setMonth) : new Date()
      let year = setYear || now.getFullYear()
      let nextYear = 0
      let month = setMonth || now.getMonth() //没有+1方便后面计算当月总天数
      let nextMonth = month + 1 > 11 ? 1 : month + 1
      let startWeek = new Date(year, month, 1).getDay() //目标月1号对应的星期
      let dayNums = new Date(year, nextMonth, 0).getDate() //获取目标月有多少天

      let obj = {}
      let num = 0
      if (month + 1 > 11) {
        nextYear = year + 1
        dayNums = new Date(nextYear, nextMonth, 0).getDate()
      }
      arrLen = startWeek + dayNums - 1
      if (startWeek == 0) {
        arrLen = 6 + dayNums
        startWeek = 7
      }
      for (let i = 0; i < arrLen; i++) {
        if (i >= startWeek - 1) {
          num = i - startWeek + 2
          obj = {
            isToday: '' + year + (month + 1 < 10 ? '0' + (month + 1) : month + 1) + (num < 10 ? '0' + num : num),
            dateNum: num,
            weight: 5,
          }
        } else {
          obj = {}
        }
        dateArr[i] = obj
      }
      this.dateArr = dateArr
      let nowDate = new Date()
      let nowYear = nowDate.getFullYear()
      let nowMonth = nowDate.getMonth() + 1
      let nowWeek = nowDate.getDay()
      let getYear = setYear || nowYear
      let getMonth = setMonth >= 0 ? setMonth + 1 : nowMonth
      if (nowYear == getYear && nowMonth == getMonth) {
        this.isTodayWeek = true
        this.todayIndex = nowWeek
      } else {
        this.isTodayWeek = false
        this.todayIndex = -1
      }
    },
    dateInitBk: function (setYear, setMonth) {
      //全部时间的月份都是按0~11基准，显示月份才+1
      let dateArr = [] //需要遍历的日历数组数据
      let arrLen = 0 //dateArr的数组长度
      let now = setYear ? new Date(setYear, setMonth) : new Date()
      let year = setYear || now.getFullYear()
      let nextYear = 0
      let month = setMonth || now.getMonth() //没有+1方便后面计算当月总天数
      let nextMonth = month + 1 > 11 ? 1 : month + 1
      let startWeek = new Date(year + ',' + (month + 1) + ',' + 1).getDay() //目标月1号对应的星期
      let dayNums = new Date(year, nextMonth, 0).getDate() //获取目标月有多少天
      let obj = {}
      let num = 0
      if (month + 1 > 11) {
        nextYear = year + 1
        dayNums = new Date(nextYear, nextMonth, 0).getDate()
      }
      arrLen = startWeek + dayNums
      for (let i = 0; i < arrLen; i++) {
        if (i >= startWeek) {
          num = i - startWeek + 1
          obj = {
            isToday: '' + year + (month + 1) + num,
            dateNum: num,
            weight: 5,
          }
        } else {
          obj = {}
        }
        dateArr[i] = obj
      }
      this.dateArr = dateArr
      let nowDate = new Date()
      let nowYear = nowDate.getFullYear()
      let nowMonth = nowDate.getMonth() + 1
      let nowWeek = nowDate.getDay()
      let getYear = setYear || nowYear
      let getMonth = setMonth >= 0 ? setMonth + 1 : nowMonth
      if (nowYear == getYear && nowMonth == getMonth) {
        ;(this.isTodayWeek = true), (this.todayIndex = nowWeek)
      } else {
        this.isTodayWeek = false
        this.todayIndex = -1
      }
    },
    /**
     * 上月切换
     */
    lastMonth: function () {
      //全部时间的月份都是按0~11基准，显示月份才+1
      let year = this.month - 2 < 0 ? this.year - 1 : this.year
      let month = this.month - 2 < 0 ? 11 : this.month - 2
      this.year = year
      this.month = month + 1
      this.dateInit(year, month)
      this.getActivities(year, month + 1)
    },
    /**
     * 下月切换
     */
    nextMonth: function () {
      //全部时间的月份都是按0~11基准，显示月份才+1
      let year = this.month > 11 ? this.year + 1 : this.year
      let month = this.month > 11 ? 0 : this.month
      this.year = year
      this.month = month + 1
      this.dateInit(year, month)
      this.getActivities(year, month + 1)
    },
    getActivities: function (year, month) {
      this.fundingData = []
      this.$request
        .get(this.$apiConfig.calendarUrl, {
          params: {
            city: '',
            year_month: year + '-' + month,
          },
        })
        .then(res => {
          let resData = res.data
          if (resData.code == 0 && resData.data) {
            let _resData = resData.data
            const dateArr = this.dateArr
            _resData.forEach((item, idx) => {
              dateArr.forEach((subitem, subidx) => {
                if (subitem.isToday == item.event_date.replace(/\-/gi, '')) {
                  //有活动
                  this.$set(this.dateArr[subidx], 'hasActivities', true)
                }
              })
            })
            this.allFundingData = _resData
            // 获取31号
            if (month === 12) {
              this.selectedDay = '20201231'
              this.filterParam.date = '20201231'
              this.fundingData = []
              this.filterProjects()
            }
          } else {
            console.log(res.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    showFunding(e) {
      this.selectedDay = e.currentTarget.dataset.date
      this.filterParam.date = e.currentTarget.dataset.date
      if (!e.currentTarget.dataset.hasactivities) {
        this.fundingData = []
        return
      }
      this.filterProjects()
    },
    filterProjects() {
      let allfundingData = Array.from(this.allFundingData)
      let fundingData = []
      allfundingData.forEach((item, idx) => {
        if (item.event_date.replace(/\-/gi, '') == this.filterParam.date) {
          if (this.filterParam.city != '全国') {
            if (item.city == this.filterParam.city) {
              fundingData.push(item)
            }
          } else {
            fundingData.push(item)
          }
        }
      })
      let selectedDate = this.filterParam.date.substring(4)
      let temp = selectedDate.substring(0, 2)
      this.selectedDate = temp + '.' + selectedDate.substring(2)
      this.fundingData = fundingData
      let T = document.querySelector('.funding-container').offsetTop
      this.$nextTick(() => {
        setTimeout(() => {
          if (fundingData.length === 0) {
            document.documentElement.scrollTop = 0
          } else {
            document.documentElement.scrollTop = T
          }
        }, 100)
      })
    },
    reset: function () {
      this.filterParam.city = '全国'
      this.filterProjects()
    },
    bindProvinceConfirm: function (e) {
      this.isShowProvince = false
      this.filterParam.city = this.selectProvince[1]
      this.filterProjects()
    },
    handleClickItem() {
      this.isShowProvince = true
    },
    handleCityChange(picker, value, index) {
      this.selectProvince = value
    },
    fillModalCancel() {},
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/v2-common.scss';

.calendar_title {
  width: pxtow(700);
  margin: pxtow(10) auto;
  justify-content: space-between;
  font-size: pxtow(200);

  display: flex;
  font-style: italic;
}

.calendar_title .icon image {
  width: pxtow(18);
  height: auto;
  margin: pxtow(5) auto;
}
.calendar_title div {
  line-height: 100%;
  width: 100%;
  text-align: center;
  font-family: 'AbsolutHeadline';
  color: #ef2ac1;
}
.calendar_title .icon {
  width: pxtow(100);
}

/* 日历 */
.calendar {
  width: 100%;
  margin-top: pxtow(20);
  padding: 0 0 pxtow(20);
  color: #fff;
  font-size: pxtow(36);
  font-family: 'Absolut';
}
.header {
  font-size: 0;
  width: pxtow(700);
  margin: 0 auto;
}
.header > div {
  display: inline-block;
  width: 14.285%;
  font-size: pxtow(30);
  text-align: center;
  /* border-bottom: 1px solid #D0D0D0; */
  padding: pxtow(20) 0;
}
.header > div:nth-of-type(1) {
  color: #da2dbf;
}
.header > div:nth-of-type(2) {
  color: #c02ebb;
}
.header > div:nth-of-type(3) {
  color: #9b2fb6;
}
.header > div:nth-of-type(4) {
  color: #7630b1;
}
.header > div:nth-of-type(5) {
  color: #5831ad;
}
.header > div:nth-of-type(6) {
  color: #342b96;
}
.header > div:nth-of-type(7) {
  color: #2f32a7;
}

.weekMark {
  position: relative;
  width: 80%;
  margin: 0 auto;
}
.weekMark div {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.date-box {
  font-size: 0;
  padding: pxtow(10) 0;
  width: pxtow(700);
  margin: 0 auto;
}
.date-box > div {
  position: relative;
  display: inline-block;
  width: 14.285%;
  text-align: center;
  vertical-align: middle;
  margin-bottom: pxtow(20);
}
.date-head {
  height: pxtow(60);
  line-height: pxtow(60);
  font-size: pxtow(36);
  font-family: 'absolute';
}

.hasActivities .date-head {
  width: pxtow(60);
  border-radius: 50%;
  text-align: center;
  color: #fff;
  margin: 0 auto;
  position: relative;
}
.hasActivities .date-head:before {
  content: '';
  background: linear-gradient(to right, rgba(239, 42, 193, 0.8), rgba(0, 51, 160, 0.8));
  display: block;
  width: pxtow(38);
  height: pxtow(15);
  border-radius: pxtow(7);
  position: absolute;
  bottom: pxtow(-14);
  left: pxtow(14);
}

.selectedDay .date-head:before {
  content: '';
  background: linear-gradient(to right, rgba(239, 42, 193, 0.8), rgba(0, 51, 160, 0.8));
  display: block;
  width: pxtow(80);
  height: pxtow(80);
  border-radius: pxtow(40);
  position: absolute;
  bottom: pxtow(-10);
  left: 50%;
  transform: translate(-50%);
}
.date-head div {
  position: relative;
}
.filter-bar {
  /* position: fixed; */
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: pxtow(55);
  padding: 0 pxtow(40);
  white-space: nowrap;
  box-sizing: border-box;
  /* box-shadow: 0 pxtow(10) pxtow(10) rgba(0, 0, 0, .5); */
  border-radius: pxtow(40);
  margin: pxtow(100) pxtow(40) pxtow(45);
  width: auto;
}
.filter-bar .pin-icon {
  width: pxtow(22);
  margin-top: pxtow(15);
  margin-right: pxtow(20);
}
.filter-bar .icon {
  width: pxtow(20);
  height: auto;
}

.filter-bar-wrapper {
  display: flex;
}
.filter-bar-wrapper picker {
  width: 100%;
}

.filter-btn {
  flex-shrink: 0;
  position: relative;
  height: pxtow(70);
  padding: 0 pxtow(20);
  margin-right: pxtow(20);
  border: pxtow(2) solid #fff;
  border-radius: pxtow(10);
  font-weight: 900;
  font-size: pxtow(30);
  color: #fff;
  background-color: transparent;
  overflow: hidden;
}

.filter-btn .iconfont {
  margin-right: pxtow(16);
}

.filter-btn.active {
  color: #fff;
  border-color: #ef2ac1;
  text-shadow: pxtow(2) pxtow(2) 0 rgba(0, 0, 0, 0.25);
  background-color: #ef2ac1;
}

.select-btn {
  display: flex;
  width: 100%;
  height: pxtow(55);
  padding: 0 pxtow(10);
  border: pxtow(2) solid #fff;
  border-radius: pxtow(10);
  align-items: center;
  background: transparent;
}

.select-btn.active {
  color: #37d32f;
  border: 0;
}

.select-btn .text {
  flex: 1;
  padding-top: pxtow(4);
  font-weight: bold;
  font-size: pxtow(22);
  color: #fff;
  /* text-shadow: pxtow(2) pxtow(2) 0 rgba(0, 0, 0, .25); */
}

.select-btn .iconfont {
  font-size: pxtow(32);
  color: #fff;
}

.bg-img {
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.new-project-item{
  margin-top: pxtow(40)!important;
}
.project-list-container {
  padding: pxtow(40) 0;
  box-sizing: border-box;
  .date {
    display: inline-block;
    font-size: pxtow(55);
    font-family: 'Absolut-Bold';
    position: relative;
    margin-bottom: pxtow(25);
    margin-left: pxtow(50);
    &::before {
      content: '';
      background: linear-gradient(to right, rgba(239, 42, 193, 0.8), rgba(0, 51, 160, 0.8));
      display: block;
      width: 110%;
      height: pxtow(20);
      border-radius: pxtow(20);
      position: absolute;
      bottom: pxtow(-14);
      left: 0;
    }
  }
  .slogen {
    margin-left: pxtow(50);
    font-size: pxtow(30);
    font-family: 'Absolut-Bold';
    line-height: pxtow(50);
  }
}
.projects-list .project-item-box {
  margin-bottom: pxtow(80);
  position: relative;
}

.gradient-bg {
  background: linear-gradient(to right, rgba(239, 42, 193, 0.5), rgba(0, 51, 160, 0.5));
}
.project-list-container {
  border-radius: 0;
}

.pop-bottom {
  width: 100%;
  height: pxtow(450);
  position: fixed;
  bottom: 0;
  left: 0;
  padding: pxtow(50) pxtow(95);
  box-sizing: border-box;
  background: #10104e;
  z-index: 2;
}
.pop-bottom .btns {
  display: flex;
  justify-content: space-between;
}
.pop-bottom .btn {
  height: pxtow(54);
}
.pop-bottom .pop-title {
  font-size: pxtow(24);
  text-align: center;
  padding: pxtow(40) 0 pxtow(20);
}
.pop-gender .options {
  display: flex;
  justify-content: space-between;
}
.pop .btns {
  display: flex;
  justify-content: center;
  margin-top: pxtow(30);
}
.pop .btns image {
  width: auto;
  height: pxtow(54);
  display: block;
  margin: 0 pxtow(5);
}
.picker-div {
  width: pxtow(634);
  height: pxtow(240);
  margin: 0 auto;
  padding: 0 pxtow(40);
  color: #ef2ac1;
  background: url('https://absolutnights.cn/static/fundingnew/profile/picker-border.png') 50% 36% no-repeat;
  background-size: 100% auto;
  box-sizing: border-box;
  margin-left: -pxtow(30);
  font-size: pxtow(24);
}
.picker-column {
  border: 0;
  color: #fff;
  height: pxtow(80);
  line-height: pxtow(80);
  padding: 0 pxtow(20);
}
.picker-column::before,
.picker-column::after {
  border: 0;
}
.picker-mask {
  background: transparent;
}
.picker-div .cur {
  color: #fff;
}
.picker-div picker-div-column:nth-of-type(1) {
  text-align: center;
}
.picker-div picker-div-column:nth-of-type(2) {
  text-align: center;
}

.picker-div picker-div-column:nth-of-type(3) {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/calendar/Calendar.vue